<template>
	<section class="tp-Ongoing__table">
		<ClientDeliveryTableReact :repairs="data" :loading="loading" />
		<div class="totalToPay">
			<span> Total a pagar: {{ total | money }}</span>
		</div>
	</section>
</template>

<script>
import { mapActions } from "vuex";
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { ClientDeliveryTable } from "@/components/client/ClientDeliveryTable";

const ClientDeliveryTableReact = ReactInVue(ClientDeliveryTable);

export default {
	components: {
		ClientDeliveryTableReact,
	},
	props: {
		data: {
			type: Array,
			default: () => [],
		},
	},

	data() {
		return {
			loading: false,
		};
	},
	computed: {
		total() {
			return this.data.reduce((total, item) => total + item.value, 0);
		},
	},
	methods: {
		...mapActions(["approveQuotation", "rejectQuotation"]),

		showQuotationMessage(entry) {
			// get the last quotation entry from the logs
			for (let i = entry.logs.length - 1; i > 0; i--) {
				const logEntry = entry.logs[i];
				if (logEntry.type === "quotation_set") {
					return logEntry.content;
				}
			}
			return "-";
		},

		/**
		 * Approve the quotation.
		 */
		approveQuotationBtnHandler(item) {
			// request confirmation to the user
			this.$confirm("Pretende aprovar o orçamento?", "Confirmação")
				.then((_) => {
					// enter in loading mode
					this.loading = true;

					// call the service to store the data permanently
					return this.approveQuotation([item.id, item.value || item.quotation]);
				})
				.then((_) => {
					// inform update
					this.$emit("update");

					// exit from the loading mode
					this.loading = false;

					// show a success message
					this.$message.success("Orçamento aprovado!");

					// Reload data
					this.fetchPage();
				})
				.catch((_) => {});
		},

		/**
		 * Reject quotation.
		 */
		rejectQuotationHandler(repair) {
			// request confirmation to the user
			this.$confirm("Pretende recusar o orçamento?", "Confirmação")
				.then((_) => {
					// enter in loading mode
					this.loading = true;

					// call the service to store the data permanently
					return this.rejectQuotation(repair.id);
				})
				.then((_) => {
					// inform update
					this.$emit("update");

					// exit from the loading mode
					this.loading = false;

					// show a success message
					this.$message.success("Orçamento recusado!");

					// Reload data
					this.fetchPage();
				})
				.catch((_) => {});
		},
	},
};
</script>
<style>
.totalToPay {
	margin-top: 8px;
	margin-bottom: 5px;
	float: right;
}
</style>
